import $ from 'jquery'
import swal from 'sweetalert'

/**
 * Serializa un objeto de parámetros en formato URL query string
 * Compatible con el formato de DataTables (arrays y objetos anidados)
 * @param {object} obj - Objeto a serializar
 * @param {string} prefix - Prefijo para keys anidados
 * @returns {string} Query string serializado
 */
const serializeParams = (obj, prefix = '') => {
	const params = [];
	
	for (let key in obj) {
		if (obj.hasOwnProperty(key)) {
			const value = obj[key];
			const fullKey = prefix ? `${prefix}[${key}]` : key;
			
			if (value !== null && value !== undefined && value !== '') {
				if (typeof value === 'object' && !Array.isArray(value)) {
					// Objeto anidado: recursión
					params.push(serializeParams(value, fullKey));
				} else if (Array.isArray(value)) {
					// Array: serializar cada elemento
					value.forEach((item, index) => {
						if (typeof item === 'object') {
							params.push(serializeParams(item, `${fullKey}[${index}]`));
						} else {
							params.push(`${encodeURIComponent(`${fullKey}[${index}]`)}=${encodeURIComponent(item)}`);
						}
					});
				} else {
					// Valor primitivo
					params.push(`${encodeURIComponent(fullKey)}=${encodeURIComponent(value)}`);
				}
			}
		}
	}
	
	return params.filter(p => p).join('&');
};

/**
 * Crea la configuración del botón de exportación a Excel para DataTables
 * @param {object} component - Componente React que tiene el ajaxHandler
 * @param {string} endpoint - Endpoint del backend para la exportación
 * @param {string} filename - Nombre del archivo a descargar
 * @param {object} intl - Objeto intl para internacionalización
 * @param {boolean} includeTableParams - Si es true, envía los parámetros de filtros y búsqueda de DataTable
 * @returns {object} Configuración del botón para DataTables
 */
export const createExcelExportButton = (component, endpoint, filename, intl, includeTableParams = false) => {
	return {
		name: 'exportExcel',
		text: '<i class="ft-upload"></i>',
		titleAttr: intl.formatMessage({ 
			id: 'actualizacionKmGrid.tools_export.exportar_a_excel', 
			defaultMessage: 'Exportar a Excel' 
		}),
		action: function (e, dt, node, config) {
			swal({
				title: intl.formatMessage({ 
					id: 'dataTableButtons.tools_export.modal_se_estan_exportando_los_datos', 
					defaultMessage: 'Se están exportando los datos.' 
				}),
				text: intl.formatMessage({ 
					id: 'dataTableButtons.tools_export.modal_esta_accion_puede_demorar', 
					defaultMessage: 'Esta acción puede demorar.' 
				}),
				buttons: {}
			});
			
			// Construir la URL con los parámetros del DataTable si se solicita
			let url = endpoint;
			if (includeTableParams) {
				const params = dt.ajax.params();
				const queryString = serializeParams(params);
				
				if (queryString) {
					url += (url.includes('?') ? '&' : '?') + queryString;
				}
			}
			
			component.ajaxHandler.fetch(url, {
				method: 'GET'
			}).then(response => {
				if (response.status === 200) {
					return response.blob();
				}
			}).then(fileBlob => {
				let fileUrl = URL.createObjectURL(fileBlob);
				$("<a />", {
					href: fileUrl,
					download: filename
				}).appendTo("body").get(0).click();
			}).catch(() => {
				swal(
					intl.formatMessage({ 
						id: 'dataTableButtons.tools_export.error_titulo', 
						defaultMessage: 'Error' 
					}), 
					intl.formatMessage({ 
						id: 'dataTableButtons.tools_export.error_mensaje', 
						defaultMessage: 'No se pudo exportar el archivo' 
					}), 
					'error'
				);
			}).finally(() => {
				swal.close();
			});
		}
	};
};

